import React, { useCallback } from 'react';
import { useStyles } from './TaskNew.styles';
import { useTranslation } from '../../contexts/translationContext';
import { PageWrapper } from '../../containers/PageWrapper';
import { HeaderPage } from '../../containers/HeaderPage/HeaderPage';
import { TaskNewForm } from '../../form/task/TaskNewForm';
import { appPaths } from '../../paths';
import { Box, Grid, Paper } from '@material-ui/core';
import { postApi } from '../../apiUtils';
import { NotificationManager } from 'react-notifications';
import { API_URL } from '../../apiTypes';
import { useHistory } from 'react-router';
import moment from 'moment';

export const TasksNew = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const handleSubmit = useCallback((values) => {
        postApi<any>({
            url: API_URL.USER_TASK_CREATE,
            data: {
                ...values,
                actionSolvedDate: values.actionSolvedDate
                    ? moment(values.actionSolvedDate).format('YYYY-MM-DD')
                    : null,
                plannedDate: values.plannedDate
                    ? moment(values.plannedDate).format('YYYY-MM-DD')
                    : null,
            },
            callAfterSuccess: () => {
                NotificationManager.success(t('Notify.item-created'));
                history.push(appPaths.TASKS);
            },
        });
    }, []);

    return (
        <PageWrapper>
            <HeaderPage
                heading={t('Tasks.new.new-headline')}
                stepName={t('Tasks.new.new-headline')}
                breadCrumbSteps={[{ name: t('Tasks.main-headline'), pathToCutCount: 1 }]}
            />
            <Grid container spacing={3}>
                <Grid item xs={5}>
                    <Paper>
                        <Box p={3}>
                            <TaskNewForm
                                buttonTitle={t('Tasks.new.btnSave')}
                                onSubmit={handleSubmit}
                                t={t}
                                goBackUrl={appPaths.TASKS}
                            />
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </PageWrapper>
    );
};
